import React from 'react';

import styled from 'styled-components';

const StyledWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;

  .radio {
    margin: 0;
    margin-right: 20px;
  }

  input {
    display: none;
  }

  label {
    display: inline-flex;
    position: relative;
    width: 100%;
    padding: 0;
    padding-left: 30px;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;

      width: 21px;
      height: 21px;

      border: 1px solid #adb5bd;
      border-radius: 50%;
    }
    ${({ disabled }) =>
      disabled &&
      `
      cursor: not-allowed;
      opacity: 0.6;
   `}
  }
  input:checked + label::before {
    border-color: #b62767;
    ${({ disabled }) =>
      disabled &&
      `
      cursor: not-allowed;
      opacity: 0.6;
   `}
  }
  input:checked + label::after {
    content: '';
    position: absolute;

    left: 3px;
    top: 3px;

    width: 15px;
    height: 15px;

    border-radius: 50%;
    background: #b62767;
    ${({ disabled }) =>
      disabled &&
      `
      cursor: not-allowed;
      opacity: 0.6;
   `}
  }
`;

type Props = {
  disabled?: boolean;
  label?: string;
  name: string;
  options: any;
  onRadioChange: (name: string, value: string) => void;
  value: boolean | string;
};

const RadioButtons = ({
  disabled = false,
  name,
  label = name,
  options,
  onRadioChange,
  value,
}: Props) => (
  <StyledWrapper disabled={disabled}>
    {options.map(option => (
      <div className='radio' key={label + option.label}>
        <input
          checked={option.value === value}
          disabled={disabled}
          id={label + option.label}
          name={name}
          onChange={e => onRadioChange(e.target.name, e.target.value)}
          type='radio'
          value={option.value}
        />
        <label htmlFor={label + option.label}>{option.label}</label>
      </div>
    ))}
  </StyledWrapper>
);

export default RadioButtons;
